export enum enmFactSheetTemplateType {
    LUXURY = 2,
    RESORT = 4,
    CITY = 3
}